import EventEmitter from 'events';

// Shared room events and view-state types, moved out of RoomPage to avoid static imports of the heavy page component.
export const RoomRefreshEmitter = new EventEmitter();
export type RoomViewState = 'loading' | 'ready' | 'playing' | 'error';
